module.exports = __webpack_public_path__ + "img/boulevard-des-airs.e3a3a641.jpg";